<era-group-list-view-ui [editEnabled]="editEnabled"
                        [groups]="groups()"
                        (toggleEditEvent)="toggleEditEvent()"
                        (addGroupEvent)="addGroupEvent()"
                        (deleteRequested)="onDeleteRequested($event)"></era-group-list-view-ui>